export default "__VITE_ASSET__DrBDFULg__"